/*
  Panier (2026-10-01) : suggestions « Pour atteindre la livraison offerte », page /cart et tiroir.
  - Remplit les emplacements [data-al-sugg] posés par snippets/alnatea-panier-franco.liquid avec la
    section alnatea-panier-suggestions (API de recommandations de Shopify). Page : dès l'affichage ;
    tiroir : seulement quand il est ouvert (aucun appel sur les pages vues sans ouvrir le panier).
  - Dawn remplace le contenu du panier à chaque changement de quantité : un MutationObserver sur
    <cart-drawer> et <cart-items> repère les nouveaux emplacements ; le HTML déjà reçu est gardé
    en mémoire (clé = produit + total + nombre d'articles) pour éviter un clignotement.
  - Bouton « Ajouter » : /cart/add.js puis mise à jour du tiroir (renderContents de Dawn) ou des
    blocs de la page (mêmes sections et sélecteurs que cart.js de Dawn).
  Chargé en defer par snippets/cart-drawer.liquid et sections/main-cart-items.liquid (garde-fou
  contre la double exécution).
*/
(function () {
  if (window.alPanierInstalle) return;
  window.alPanierInstalle = true;

  var cache = {};

  function remplir(zone) {
    var tiroir = zone.closest('cart-drawer');
    if (tiroir && !tiroir.classList.contains('active')) return;
    if (zone.dataset.charge) return;
    zone.dataset.charge = '1';
    var cle = zone.dataset.cle;
    function poser(html) {
      if (!html) { zone.hidden = true; return; }
      zone.innerHTML = html;
      zone.hidden = false;
    }
    if (cle in cache) { poser(cache[cle]); return; }
    fetch('/recommendations/products?product_id=' + zone.dataset.alSugg + '&limit=10&section_id=alnatea-panier-suggestions&intent=related')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var bloc = new DOMParser().parseFromString(t, 'text/html').querySelector('.al-sugg');
        cache[cle] = bloc ? bloc.outerHTML : '';
        poser(cache[cle]);
      })
      .catch(function () { zone.hidden = true; });
  }

  function scanner() {
    document.querySelectorAll('[data-al-sugg]:not([data-charge])').forEach(remplir);
  }

  function remplacer(idCible, html) {
    var cible = document.getElementById(idCible);
    var source = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
    var dest = cible && cible.querySelector('.js-contents');
    if (source && dest) dest.innerHTML = source.innerHTML;
  }

  function ajouter(bouton) {
    var tiroir = bouton.closest('cart-drawer');
    var itemsPage = document.getElementById('main-cart-items');
    var piedPage = document.getElementById('main-cart-footer');
    var sections = tiroir ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    if (!tiroir && itemsPage) sections.push(itemsPage.dataset.id);
    if (!tiroir && piedPage) sections.push(piedPage.dataset.id);
    bouton.disabled = true;
    bouton.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(bouton.dataset.alPanierAjout), quantity: 1 }], sections: sections.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) throw d;
        if (tiroir) { tiroir.renderContents(d); return; }
        var bulle = document.getElementById('cart-icon-bubble');
        var htmlBulle = d.sections && d.sections['cart-icon-bubble'];
        if (bulle && htmlBulle) {
          var s = new DOMParser().parseFromString(htmlBulle, 'text/html').querySelector('.shopify-section');
          if (s) bulle.innerHTML = s.innerHTML;
        }
        if (itemsPage) remplacer('main-cart-items', d.sections[itemsPage.dataset.id]);
        if (piedPage) remplacer('main-cart-footer', d.sections[piedPage.dataset.id]);
      })
      .catch(function () {
        bouton.textContent = 'Indisponible';
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-al-panier-ajout]');
    if (!b) return;
    e.preventDefault();
    ajouter(b);
  });

  function brancher() {
    var obs = new MutationObserver(scanner);
    document.querySelectorAll('cart-drawer, cart-items').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    scanner();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
})();
